<template>
  <div :class="isAdminPanelRoute ? 'DEBUG-NO-CLASS' : { 'container-user': isUserAccount }">
  <!-- Debug info -->
 
  
  <!-- rest of your template -->
    <app-user-navigation v-if="isUserAccount">
    </app-user-navigation>

    <b-navbar toggleable="lg" type="dark" class="mt-2"  v-if="!isUserAccount">
      <b-navbar-brand href="#" class="onco-logo">
        <img
          class="logo"
          alt="Vue logo"
          style="height: 3rem"
          src="../assets/ProxyMed_Logo_RGB.png"
        />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="menuItems">
          <b-nav-item v-for="item in menuItems" :key="item.route" class="">
            <router-link
              :class="isActive(item.route)"
              :to="item.route"
              class="nav-link"
              v-on:click.native="onToggleMenu"
              >{{ item.name }}
            </router-link>
          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <em>{{ greeting }}</em>
            </template>
            <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Account } from "@/entities/auth/Account";
import { Role } from "@/entities/auth/Role";
import AppUserNavigation from "./AppUserNavigation.vue";

@Component({
  components: {
    AppUserNavigation
  },
})
export default class AppNavigation extends Vue {
  get menuItems(): { route: string; name: string }[] | null {
    const account = this.$store.getters[
      "authentication/account"
    ] as Account | null;
    if (account == null) return null;

    switch (account.role) {
      case Role.Expert:
        return [
          {
            route: "/tools/edit",
            name: "My Opinion"
          },
          {
            route: "/tools/ratings",
            name: "Ratings"
          },
          {
            route: "/selfCheck",
            name: "Check Data"
          },
          {
            route: "/tools/new",
            name: "Add New"
          },
          {
            route: "/voting",
            name: "Voting"
          },
          {
            route: "/reports",
            name: "Completeness"
          }
        ];

      case Role.Admin:
        return [
        {
            route: "/admin/AdminPanel",
            name: "User Management"
          },

          {
            route: "/admin/TestDetails",
            name: "Test Analysis"
          },
          {
            route: "/admin/dataLoad",
            name: "Data Load"
          },
          {
            route: "/admin/tnmConfiguration",
            name: "TNM Configuration"
          },
          {
            route: "/admin/reports",
            name: "Completeness"
          },
          {
            route: "/settings",
            name: "System Settings"
          }
          
        ];

      default:
        return null;
    }
  }

  get isUserAccount() {
    const account: Account = this.$store.getters["authentication/account"];
    return  account.role === Role.User;
  }

  get isAdminPanelRoute() {
    return this.$route.path === '/admin/AdminPanel';
  }

  isActive(route: string): string {
    return this.$route.path === route ? "active" : "";
  }

  get isMenuOpened() {
    return this.$store.state.menu.isOpened;
  }

  onToggleMenu() {
    this.$store.dispatch("menu/toggleMenu");
  }

  created() {
    const mobile = window.matchMedia("screen and (max-width: 576px)");
    mobile.addListener(media => {
      if (!media.matches) return;
      this.$store.dispatch("menu/closeMenu");
    });
  }
  mounted() {
  console.log('=== AppNavigation Debug ===');
  console.log('Current route path:', this.$route.path);
  console.log('Is admin panel route:', this.isAdminPanelRoute);
  console.log('Route path === "/admin/AdminPanel":', this.$route.path === '/admin/AdminPanel');
}

  get greeting() {
    const account: Account = this.$store.getters["authentication/account"];

    if (account.role === Role.User) return "User";
    else return account.name + " " + account.surname;
  }

  logout(): void {
    this.$store.dispatch("authentication/logout");
  }
}
</script>

<style scoped lang="scss">
.navbar {
  background-color: #2F45A5;
}

.nav-link {
  color: #fff;
  background-color: #2F45A5;
  transition-duration: 0.2s;
}

.onco-logo {
  background: white;
  padding: 0.5rem 0.6rem 0.5rem 0.5rem;
  margin: 0.3rem;
  border-radius: 8rem;
}
</style>